// Search only the published records returned by the membership-protected API.
export function foldTerm(value = '') {
  return value.toLocaleLowerCase('tr').replace(/ı/g, 'i').normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').replace(/[’'ʻʼ]/g, '')
    .replace(/[^\p{L}\p{N}]+/gu, ' ').trim().replace(/\s+/g, ' ');
}
export function queryTerm(value) {
  return foldTerm(value).replace(/\b(nedir|ne demek|anlami|hakkinda|aciklamasi)\b/g, '').trim();
}
const names = item => [item.title, ...(item.body?.topics || [])].map(foldTerm);
export function searchGlossary(items, query, rifaiOnly = false) {
  const needle = queryTerm(query);
  return items.filter(item => (!rifaiOnly || names(item).includes('rifai gelenegi')) &&
    (!needle || needle.split(' ').every(word => foldTerm([item.title, item.body?.text, ...(item.body?.topics || [])].join(' ')).includes(word))))
    .sort((a, b) => {
      const score = item => names(item).includes(needle) ? 0 : foldTerm(item.title).startsWith(needle) ? 1 : 2;
      return score(a) - score(b) || a.title.localeCompare(b.title, 'tr');
    });
}
function distance(a, b) {
  let row = Array.from({length: b.length + 1}, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    const next = [i];
    for (let j = 1; j <= b.length; j++) next[j] = Math.min(next[j - 1] + 1, row[j] + 1, row[j - 1] + (a[i - 1] !== b[j - 1]));
    row = next;
  }
  return row[b.length];
}
export function glossarySuggestions(items, query) {
  const needle = queryTerm(query);
  if (needle.length < 4 || needle.length > 60) return [];
  return items.map(item => ({item, distance: Math.min(...names(item).map(name => distance(needle, name)))}))
    .filter(x => x.distance <= Math.min(2, Math.floor(needle.length / 4)))
    .sort((a, b) => a.distance - b.distance || a.item.title.localeCompare(b.item.title, 'tr'))
    .slice(0, 3).map(x => x.item);
}
export function sourceLink(locator = '') {
  const value = locator.match(/https:\/\/[^\s]+/)?.[0];
  if (!value) return null;
  try {
    const url = new URL(value);
    return url.hostname === 'islamansiklopedisi.org.tr' && !url.username && !url.password && !url.port
      ? url.href : null;
  } catch { return null; }
}
